/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.permissions.controllers', [])

.controller('PermissionsController', ['$scope', function($scope) {

    $scope.permissions = {

      model: "Your spankin new application.permissions.default view!",

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.permissions.init();

}]);